import { useState, useEffect } from "react";
import "../../../entrydoor.css";
import "../finish/WinColor.css";
import useGrillData from './useGrillData';

const GrillColor = ({
  controlId,
  value = {},
  onChange,
  label = "Grill Color",
  colorType = 'interior',  // 'interior' or 'exterior'
  disabled = false,
  appliesTo = 'windows'
}) => {
  const [selectedColor, setSelectedColor] = useState(value);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { getGrillInternalColors, getGrillExternalColors, loading, error } = useGrillData(appliesTo);

  // Get colors based on type
  const colors = colorType === 'interior' ? getGrillInternalColors() : getGrillExternalColors();

  useEffect(() => {
    setSelectedColor(value);
  }, [value?.value]);

  // Set default value when colors are loaded and no value is selected
  useEffect(() => {
    if (!loading && colors.length > 0 && !selectedColor?.value) {
      const defaultOption = colors[0];
      const newValue = { value: defaultOption.value, label: defaultOption.label };
      setSelectedColor(newValue);
      onChange(newValue);
    }
  }, [loading, colors]);

  const handleSelect = (option) => {
    const newValue = { value: option.value, label: option.label };
    setSelectedColor(newValue);
    onChange(newValue);
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    if (!disabled) {
      setIsDropdownOpen(prev => !prev);
    }
  };

  const handleBlur = () => {
    setTimeout(() => setIsDropdownOpen(false), 100);
  };

  if (error) {
    console.error('Error loading grill colors:', error);
  }

  return (
    <div className="a-container">
      <label htmlFor="GrillColor">{label}</label>
      <div
        className="custom-dropdown"
        style={{ zIndex: isDropdownOpen ? 1000 + controlId : 1 }}
      >
        <div
          className="dropdown-header"
          onClick={toggleDropdown}
          onBlur={handleBlur}
          style={{ cursor: disabled ? "default" : "pointer" }}
          tabIndex={disabled ? -1 : 0}
        >
          <div
            className="color-circle"
            style={{
              backgroundColor: selectedColor?.value || "transparent",
            }}
          />
          <span>{loading ? "Loading..." : (selectedColor?.label || "Select a color")}</span>
        </div>

        {isDropdownOpen && !loading && (
          <div className="dropdown-options">
            {colors.map((option, index) => (
              <div
                key={`${option.id}-${index}`}
                className="dropdown-option"
                onMouseDown={() => handleSelect(option)}
              >
                <div
                  className="color-circle"
                  style={{ backgroundColor: option.value }}
                />
                <span>{option.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GrillColor;
